import { render, staticRenderFns } from "./OtherParts.vue?vue&type=template&id=4b54279e&scoped=true&"
import script from "./OtherParts.vue?vue&type=script&lang=js&"
export * from "./OtherParts.vue?vue&type=script&lang=js&"
import style0 from "./OtherParts.vue?vue&type=style&index=0&id=4b54279e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b54279e",
  null
  
)

export default component.exports